@use '@/styles/tokens' as *;
@use '@/styles/popup' as *;

.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: $radius-pill;
  background: none;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: $color-control-hover;
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }
}

.popup {
  :global(.ant-dropdown-menu) {
    @include popup-chrome;
  }

  :global(.ant-dropdown-menu-item) {
    @include popup-item;
  }

  :global(.ant-dropdown-menu-item-group-title) {
    padding: 10px 12px 4px;
    font-size: 12px;
    font-weight: var(--font-weight-medium);
    color: var(--text-muted);
  }

  :global(.ant-dropdown-menu-item-danger) {
    color: $color-error-900;
  }

  :global(.ant-dropdown-menu-item-icon svg) {
    width: 16px;
    height: 16px;
  }
}

.itemBody {
  display: flex;
  flex-direction: column;
}

.itemTitle {
  font-size: 14px;
}

.itemDescription {
  font-size: 12px;
  color: var(--text-muted);
}
